"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LangSelection = void 0;
var _hooks = require("../../../../hooks");
var _Header = require("../Header.labels");
var _Header2 = _interopRequireDefault(require("../Header.styles"));
var _ARLang = _interopRequireDefault(require("../resources/ARLang.svg"));
var _HELang = _interopRequireDefault(require("../resources/HELang.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LangSelection = function LangSelection(props) {
  var isMobileView = props.isMobileView,
    user = props.user,
    lang = props.lang,
    langs = props.langs,
    onLanguageChange = props.onLanguageChange;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  var styles = (0, _Header2.default)(isMobileView, !Boolean(user === null || user === void 0 ? void 0 : user.userId));
  if ((langs === null || langs === void 0 ? void 0 : langs.length) <= 1) return null;
  var handleLanguageChange = function handleLanguageChange() {
    var currentIndex = langs.findIndex(function (l) {
      return l === lang;
    });
    var nextIndex = (currentIndex + 1) % langs.length;
    var nextLang = langs[nextIndex];
    onLanguageChange(nextLang);
  };
  var getLangImage = function getLangImage(lang) {
    switch (lang) {
      case 'he':
        return _HELang.default;
      case 'ar':
        return _ARLang.default;
      default:
        return '';
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    onClick: handleLanguageChange,
    "aria-label": "".concat(getLabel('select_language'), ": ").concat(getLabel(lang)),
    className: styles['cc-Header__toolbar__lang-button'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: getLangImage(lang),
      "aria-label": getLabel(lang),
      alt: getLabel(lang),
      className: styles['cc-Header__toolbar__lang-image']
    })
  });
};
exports.LangSelection = LangSelection;